import { makeResetStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeResetStyles({
  display: 'flex',
  flexDirection: 'row',
  '& .filters-card': {
    width: '320px',
    '& .filters-list': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      paddingLeft: '4px',
      paddingRight: '4px',
      paddingTop: '8px',
      paddingBottom: '8px',
      '& .filter-wrapper': {
        width: '80px',
        height: '100px',
        ...shorthands.border('none'),
        ...shorthands.padding('0'),
        backgroundColor: '#fff',
        '& img': {
          width: '100%',
          height: '80px',
          ...shorthands.borderRadius('8px'),
          objectFit: 'cover',
        },
        '&.selected': {
          '& img': {
            ...shorthands.outline('2px', 'solid', tokens.colorBrandBackground),
            outlineOffset: '1px',
            ...shorthands.borderRadius('8px'),
          },
        },
        '& .filter-name': {
          fontSize: '10px',
          textAlign: 'center',
          lineHeight: '14px',
          fontWeight: 600,
          ...shorthands.gap('4px'),
        },
      },
    },
  },
  '& .blur-card': {
    width: '320px',
    marginTop: '12px',
    '& .blur-header': {
      display: 'flex',
      alignItems: 'center',
      height: '36px',
      '& svg': {
        marginRight: '10px',
        marginLeft: '8px',
      },
    },
    '& .blur-slider': {
      width: '100%',
      '& .blur-slider-value-wrapper': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        lineHeight: '20px',
        '& .blur-slider-label': {
          marginLeft: '8px',
        },
        '& .blur-slider-value': {
          marginRight: '8px',
        },
      },
    },
    '& .blur-slider-control': {
      width: '100%',
    },
    '& .blur-switch': {
      '&.fui-Switch input': {
        width: '100%',
        height: '100%',
      },
    },
  },
});
